import { BaseProgressionStrategy } from './BaseProgressionStrategy.js';

export class ElectronicProgressionStrategy extends BaseProgressionStrategy {
  build(ctx) {
    if (ctx.scale.length >= 7) {
      const choice = this.pick(ctx, [[0, 5, 3, 4], [0, 0, 3, 3], [0, 3, 5, 4], [5, 3, 0, 4]]);
      return choice.map(deg => this.triad(ctx, deg));
    }
    return [this.triad(ctx, 0), this.triad(ctx, 3)];
  }
}
